import 'ui-core/components/accordion/js/accordion';

UX.accordion.additionalControls = function () {
    $('.accordion').on('click', '[data-type="ajax"]', function () {
        const $this = $(this),
            $content = $this.parents('.accordion').find('[data-ajax-content]'),
            ajaxData = $content.data('ajax-content'),
            spinner = '<div class="accordion__loading loading"></div>';
        if (!$content.hasClass('js--loaded')) {
            $content.html(spinner);
            $.ajax(ajaxData, {
                success: function (data) {
                    $content.addClass('js--loaded');
                    $content.html(data);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $content.html('Server error occurred');
                },
            });
        }
    });
};
